import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { getWorklists, worklistKeys } from "@/features/worklists/worklists.api";
import { WorklistsClient } from "@/features/worklists/WorklistsClient";

export const Route = createFileRoute("/_shell/worklists")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "worklists")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: WorklistsScreen,
});

function WorklistsScreen() {
  const { t } = useTranslation();
  const { data, isPending, isError, error } = useQuery({
    queryKey: worklistKeys.catalog,
    queryFn: getWorklists,
  });

  return (
    <div className="wl-page" data-screen-label="Back-office Worklists">
      {isPending && <p className="t-body-sm t-muted">{t("common.loading")}</p>}
      {isError && (
        <div className="wl-alert wl-alert--danger">
          {error instanceof Error ? error.message : String(error)}
        </div>
      )}
      {data && <WorklistsClient catalog={data} />}
    </div>
  );
}
